import * as React from "react";
import PropTypes from "prop-types";
const SvgNavigationInformationHighlightedXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M8 0a8 8 0 100 16A8 8 0 008 0zm.625 4v1.25h-1.25V4zm0 8h-1.25V7h1.25z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationInformationHighlightedXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgNavigationInformationHighlightedXsmall;
